import apiBase from "../../api/axios";

/**
 * Servicio para el flujo de Conversación Plantel (Mentor/Estudiante).
 * Base URL: /api/v1/conversacion/
 */

// 1. Mentor inicia una sesión
export const iniciarConversacionService = async (payload) => {
  const response = await apiBase.post("v1/conversacion/iniciar/", payload);
  return response.data;
};

// 2. Obtener sesión activa del usuario
export const getSesionActualService = async () => {
  const response = await apiBase.get("v1/conversacion/sesion-actual/");
  return response.data;
};

// 3. Cargar configuraciones de la sesión
export const getConfiguracionesService = async (sesionId) => {
  const response = await apiBase.get(
    `v1/conversacion/configuraciones/?sesion_id=${sesionId}`,
  );
  return response.data;
};

// 4. Guardar respuesta de texto
export const responderService = async (payload) => {
  const response = await apiBase.post("v1/conversacion/responder/", payload);
  return response.data;
};

// 5. Guardar respuesta con archivos multimedia
export const responderConMediaService = async (formData) => {
  const response = await apiBase.post(
    "v1/conversacion/responder-con-media/",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
  return response.data;
};

// 6. Adjuntar archivos a una respuesta existente
export const adjuntarMediaService = async (formData) => {
  const response = await apiBase.post(
    "v1/conversacion/adjuntar-media/",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
  return response.data;
};

// 7. Eliminar un archivo multimedia (soft-delete)
export const eliminarMediaService = async (mediaId) => {
  const response = await apiBase.delete(
    `v1/conversacion/eliminar-media/${mediaId}/`,
  );
  return response.data;
};

// 8. Marcar sesión como completada
export const completarSesionService = async (payload) => {
  const response = await apiBase.post("v1/conversacion/completar/", payload);
  return response.data;
};

// 9. Listar sesiones del usuario
export const getMisSesionesService = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.estado) query.append("estado", params.estado);
  if (params.rol) query.append("rol", params.rol);
  const queryStr = query.toString();
  const response = await apiBase.get(
    `v1/conversacion/mis-sesiones/${queryStr ? `?${queryStr}` : ""}`,
  );
  return response.data;
};

// 10. Ver resumen detallado de una sesión
export const getResumenService = async (sesionId) => {
  const response = await apiBase.get(
    `v1/conversacion/resumen/?sesion_id=${sesionId}`,
  );
  return response.data;
};
